import type { AuthPageCopy } from '@/i18n/auth-page-copy';

export type CredentialRecoveryReason =
  | 'invalid-credentials'
  | 'email-verified-password-required';

export type CredentialRecoveryEvent =
  | { type: 'show'; reason: CredentialRecoveryReason }
  | { type: 'credential-input' }
  | { type: 'new-submit' };

export function parseCredentialRecoveryReason(
  value: string | null
): CredentialRecoveryReason | null {
  return value === 'invalid-credentials' ||
    value === 'email-verified-password-required'
    ? value
    : null;
}

export function reduceCredentialRecoveryReason(
  _current: CredentialRecoveryReason | null,
  event: CredentialRecoveryEvent
): CredentialRecoveryReason | null {
  return event.type === 'show' ? event.reason : null;
}

export function getCredentialRecoveryMessage(
  reason: CredentialRecoveryReason,
  copy: Pick<AuthPageCopy, 'invalidCredentials' | 'emailVerifiedEnterPassword'>
): string {
  return reason === 'email-verified-password-required'
    ? copy.emailVerifiedEnterPassword
    : copy.invalidCredentials;
}
